export default __webpack_public_path__ + "static/media/logogoodwoodfinal42.ac321f84.png";